import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import * as XLSX from "xlsx";
import {
  ScholarshipManagementDto,
  StateDto,
  LgaDto,
  ScholarshipTypeDto,
  ScholarshipCategoryDto,
  ScholarshipSessionDto,
  ScholarshipAwardDurationDto,
  CommunityDto,
  CourseOfStudyDto,
  EpimsGenderDto,
  CountryDto,
} from "@cradua/data";
import { TooltipPosition } from "@angular/material/tooltip";
import { FormControl } from "@angular/forms";

type AOA = any[][];

@Component({
  selector: "mrsoftapps-scholarship-management",
  templateUrl: "./scholarship-management.component.html",
  styleUrls: ["./scholarship-management.component.scss"],
})
export class ScholarshipManagementComponent implements OnInit {
  willDownload = false;
  fileName: string = "Student-record.xlsx";
  data: AOA = [
    [1, 2],
    [3, 4],
  ];
  studentAoA: AOA = [[], []];

  @Input()
  countries: CountryDto[];
  @Input()
  states: StateDto[];
  @Input()
  lgas: LgaDto[];
  @Input()
  scholarshipTypes: ScholarshipTypeDto[];
  @Input()
  scholarshipCategories: ScholarshipCategoryDto[];
  @Input()
  courseOfStudies: CourseOfStudyDto[];
  @Input()
  scholarshipSessions: ScholarshipSessionDto[];
  @Input()
  scholarshipAwardDurations: ScholarshipAwardDurationDto[];
  @Input()
  genders: EpimsGenderDto[];
  @Input()
  communities: CommunityDto[];
  @Input()
  scholarshipManagements: ScholarshipManagementDto[];
  @Output()
  changeEmit = new EventEmitter<any>();
  @Output()
  taskEmit = new EventEmitter<any>();
  positionOptions: TooltipPosition[] = [
    "after",
    "before",
    "above",
    "below",
    "left",
    "right",
  ];
  position = new FormControl(this.positionOptions[0]);
  managementRecords: any[];

  constructor() {}

  ngOnInit() {}

  // check if the fields exist

  onBack() {
    this.taskEmit.emit("list");
  }

  checkGender(value: string) {
    const foundGender = this.genders.find(
      (gender) =>
        gender.GenderName.toLowerCase() === value.trim().toLowerCase(),
    );
    return foundGender ? true : false;
  }

  checkState(value: string) {
    const foundState = this.states.find(
      (state) => state.StateName.toLowerCase() === value.trim().toLowerCase(),
    );
    return foundState ? true : false;
  }

  checkLga(value: string) {
    const foundLga = this.lgas.find(
      (lga) => lga.LgaName.toLowerCase() === value.trim().toLowerCase(),
    );
    return foundLga ? true : false;
  }

  checkCountry(value: string) {
    const foundCountry = this.countries.find(
      (country) =>
        country.CountryName.toLowerCase() === value.trim().toLowerCase(),
    );
    return foundCountry ? true : false;
  }

  checkCourseOfStudy(value: string) {
    const foundCourseOfStudy = this.courseOfStudies.find(
      (course) =>
        course.CourseOfStudyName.toLowerCase() === value.trim().toLowerCase(),
    );
    return foundCourseOfStudy ? true : false;
  }

  checkScholarshipType(value: string) {
    const foundScholarshipType = this.scholarshipTypes.find(
      (scholarshipType) =>
        scholarshipType.ScholarshipTypeName.toLowerCase() ===
          value.trim().toLowerCase(),
    );
    return foundScholarshipType ? true : false;
  }

  checkScholarshipCategory(value: string) {
    const foundScholarshipCategory = this.scholarshipCategories.find(
      (scholarshipCategory) =>
        scholarshipCategory.ScholarshipCategoryName.toLowerCase() ===
          value.trim().toLowerCase(),
    );
    return foundScholarshipCategory ? true : false;
  }

  checkScholarshipSession(value: string) {
    const foundScholarshipSession = this.scholarshipSessions.find(
      (scholarshipSession) =>
        scholarshipSession.ScholarshipSessionName.toLowerCase() ===
          value.trim().toLowerCase(),
    );
    return foundScholarshipSession ? true : false;
  }

  checkScholarshipAwardDuration(value: string) {
    const foundScholarshipAwardDuration = this.scholarshipAwardDurations.find(
      (award) =>
        award.ScholarshipAwardDurationName.toLowerCase() ===
          value.trim().toLowerCase(),
    );
    return foundScholarshipAwardDuration ? true : false;
  }

  checkCommunity(value: string) {
    const foundCommunity = this.communities.find(
      (community) =>
        community.CommunityName.toLowerCase() === value.trim().toLowerCase(),
    );
    return foundCommunity ? true : false;
  }

  checkUserEmail(value: string) {
    const foundUser = this.scholarshipManagements.find(
      (user) => user.ContactEmail.toLowerCase() === value.trim().toLowerCase(),
    );
    return foundUser ? false : true;
  }

  // This method handle excel uploading
  onFileChange(ev) {
    let workBook = null;
    let jsonData = null;
    const reader = new FileReader();
    const file = ev.target.files[0];
    reader.onload = (event) => {
      const data = reader.result;
      workBook = XLSX.read(data, { type: "binary" });
      /* grab first sheet */
      const wsname: string = workBook.SheetNames[0];
      const ws: XLSX.WorkSheet = workBook.Sheets[wsname];

      /* save data */
      this.data = <AOA> XLSX.utils.sheet_to_json(ws, { header: 1 });
      jsonData = workBook.SheetNames.reduce((initial, name) => {
        const sheet = workBook.Sheets[name];
        initial[name] = XLSX.utils.sheet_to_json(sheet);
        return initial;
      }, {});

      this.managementRecords = jsonData.Sheet1;
    };
    reader.readAsBinaryString(file);
  }

  downloadFile() {
    let link = document.createElement("a");
    link.setAttribute("type", "hidden");
    link.href =
      "http://localhost:3333/api/scholarship-management/file-upload/Scholarship-management-upload.xlsx";
    link.download = "filename";
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  export(): void {
    /* generate worksheet */
    console.log(this.studentAoA);
    const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(this.studentAoA);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    /* save to file */
    XLSX.writeFile(wb, this.fileName);
  }

  onSubmit() {
    this.changeEmit.emit(this.managementRecords);
  }
}
